export class ExamesCargosModel {
  id: number;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
  ordem?: number;
}



// WEBPACK FOOTER //
// ./src/app/exames/cargos/exames-cargos.model.ts